(function() {
    'use strict';

    angular.module('caffeprint')
        .directive('cpInputDatepicker', cpInputDatepicker);

    cpInputDatepicker.$inject = ['dateFormatConst', 'momentSrvc'];

    function cpInputDatepicker(dateFormatConst, momentSrvc) {
        return {
            restrict: 'E',
            replace: true,
            transclude: true,
            templateUrl: 'app/caffeprint/directives/input-datepicker/input-datepicker.html',
            scope: {
                title: '@',
                labelClass: '@?',
                containerClass: '@',
                object: '=',
                prop: '@',
                format: '@',
                minMode: '@',
                maxDate: '@',
                isRequired: '=?',
                isDisabled: '=?',
                onChange: '&?',
                enableWeekends: '=?'
            },
            link: function(scope, element, attrs, controller) {
                scope.format = scope.format ? scope.format : dateFormatConst.datePicker;
                scope.isOpened = false;
                scope.openPopup = openPopup;

                scope.change = change;
                scope.proxyDate = null;

                scope.getLabelClass = getLabelClass;
                scope.getContainerClass = getContainerClass;

                scope.dateOptions = {
                    dateDisabled: momentSrvc.disabledWeekends,
                    minDate: momentSrvc.moment(dateFormatConst.datePickerMin).toDate(),
                    maxDate: scope.maxDate ?
                        momentSrvc.strToDate(scope.maxDate) :
                        momentSrvc.moment(dateFormatConst.datePickerMax).toDate(),
                };

                if (scope.minMode) {
                    scope.dateOptions.minMode = scope.minMode;
                }

                if (scope.enableWeekends) {
                    scope.dateOptions.dateDisabled = null;
                }

                scope.$watch('object', function(newValue, oldValue) {
                    if (scope.object && scope.object[scope.prop]) {
                        scope.proxyDate = momentSrvc.strToDate(scope.object[scope.prop]);
                    }
                });

                function change() {
                    scope.object[scope.prop] = scope.proxyDate ? momentSrvc.dateToStr(scope.proxyDate) : null;

                    if (scope.onChange) {
                        scope.onChange();
                    }
                }

                function openPopup() {
                    scope.isOpened = true;
                }

                function getLabelClass() {
                    if (scope.labelClass) {
                        return scope.labelClass;
                    } else {
                        return 'col-sm-2';
                    }
                }

                function getContainerClass() {
                    if (scope.containerClass) {
                        return scope.containerClass;
                    } else {
                        return 'col-sm-10';
                    }
                }
            }
        };
    }
})();
